import { INPUT_FIELD_TYPES } from './input-field-types';
import { READONLY_FIELD_TYPES } from './readonly-field-types';
import { DEXT_FIELD_TYPES } from './dext-field-types';
const TEXT_INPUT_FIELD_TYPES = {
  [INPUT_FIELD_TYPES.ECOM_ADDITIONAL_INFO]: INPUT_FIELD_TYPES.ECOM_ADDITIONAL_INFO,
  [INPUT_FIELD_TYPES.CONTACTS_FIRST_NAME]: INPUT_FIELD_TYPES.CONTACTS_FIRST_NAME,
  [INPUT_FIELD_TYPES.CONTACTS_LAST_NAME]: INPUT_FIELD_TYPES.CONTACTS_LAST_NAME,
  [INPUT_FIELD_TYPES.CONTACTS_EMAIL]: INPUT_FIELD_TYPES.CONTACTS_EMAIL,
  [INPUT_FIELD_TYPES.CONTACTS_PHONE]: INPUT_FIELD_TYPES.CONTACTS_PHONE,
  [INPUT_FIELD_TYPES.CONTACTS_ADDRESS]: INPUT_FIELD_TYPES.CONTACTS_ADDRESS,
  [INPUT_FIELD_TYPES.CONTACTS_COMPANY]: INPUT_FIELD_TYPES.CONTACTS_COMPANY,
  [INPUT_FIELD_TYPES.CONTACTS_POSITION]: INPUT_FIELD_TYPES.CONTACTS_POSITION,
  [INPUT_FIELD_TYPES.CONTACTS_TAX_ID]: INPUT_FIELD_TYPES.CONTACTS_TAX_ID,
  [INPUT_FIELD_TYPES.CONTACTS_NUMBER_INPUT]: INPUT_FIELD_TYPES.CONTACTS_NUMBER_INPUT,
  [INPUT_FIELD_TYPES.CONTACTS_TEXT_INPUT]: INPUT_FIELD_TYPES.CONTACTS_TEXT_INPUT,
  [INPUT_FIELD_TYPES.CONTACTS_DATE_INPUT]: INPUT_FIELD_TYPES.CONTACTS_DATE_INPUT,
  [INPUT_FIELD_TYPES.CONTACTS_URL_INPUT]: INPUT_FIELD_TYPES.CONTACTS_URL_INPUT,
  [INPUT_FIELD_TYPES.TEXT_INPUT]: INPUT_FIELD_TYPES.TEXT_INPUT,
  [INPUT_FIELD_TYPES.NUMBER_INPUT]: INPUT_FIELD_TYPES.NUMBER_INPUT,
  [INPUT_FIELD_TYPES.URL_INPUT]: INPUT_FIELD_TYPES.URL_INPUT,
  [INPUT_FIELD_TYPES.QUIZ_SHORT_TEXT]: INPUT_FIELD_TYPES.QUIZ_SHORT_TEXT,
  [INPUT_FIELD_TYPES.QUIZ_NUMBER]: INPUT_FIELD_TYPES.QUIZ_NUMBER
};
export const FIELD_TYPES = {
  ...INPUT_FIELD_TYPES,
  ...READONLY_FIELD_TYPES
};
// eslint-disable-next-line @typescript-eslint/no-redeclare

export { INPUT_FIELD_TYPES };
export { READONLY_FIELD_TYPES };
export { DEXT_FIELD_TYPES };
//# sourceMappingURL=field-types.js.map